import api from './axiosConfig';

// Para desarrollo
export function getVirtualAgentWsUrl(): string {
  return 'ws://127.0.0.1:3004/ws';
}

// Obtiene la URL base para conectarse al WebSocket del agente virtual
export async function getAuthenticatedWsUrl(): Promise<string> {
  // Para desarrollo - URL local directa
  if (import.meta.env.VITE_NODE_ENV !== 'production') {
    // console.log(
    //   'URL de desarrollo del WebSocket obtenida: ws://127.0.0.1:3004/ws'
    // );
    return 'ws://127.0.0.1:3004/ws';
  }

  // Para producción - obtiene URL segura desde el backend usando axios
  try {
    const response = await api.get('/virtual-agent/ws-auth');
    // console.log('URL del WebSocket obtenida:', response.data.url);
    return response.data.url;
  } catch (error) {
    console.error('Error obteniendo URL del WebSocket:', error);
    throw error;
  }
}
